export class SearchAllSection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sectionId",
            "baseName": "sectionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SearchAllType",
            "format": ""
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SearchAllSectionStatus",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<SearchAllSectionResult>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllSection.attributeTypeMap;
    }
    constructor() {
    }
}
